import path from 'path'
import axios from 'axios'
import { SystemPath } from './CSInterface'

const downloadFiles = (files, directory) => {
  return files.map(file => {
    return new Promise((resolve, reject) => {
      const { url } = file
      let fileName = file.format
        ? `${file.name}.${file.format}`
        : url.replace(/^.*[\\/]/, '').split('?')[0]

      let requestParams = {
        url,
        responseType: 'arraybuffer',
      }

      // In case of InDesign Convert & Download PDF file
      if (
        window.cs.getHostEnvironment().appId === 'IDSN' &&
        file.format === 'svg'
      ) {
        // Replace File Name with .pdf
        fileName = fileName.replace('.svg', '.pdf')

        requestParams = {
          ...requestParams,
          url: window.location.origin + '/process/svg-to-pdf',
          method: 'post',
          data: {
            url,
          },
        }
      }

      axios(requestParams).then(response => {
        const buffer = new Uint8Array(response.data)
        const dataBuffer = new Array(buffer.length)

        for (let i = 0; i < buffer.length; i++) {
          dataBuffer[i] = String.fromCharCode(buffer[i])
        }

        const c = dataBuffer.join('')
        const fileData = window.btoa(c)

        const filePath = directory + fileName

        const result = window.cep.fs.writeFile(
          filePath,
          fileData,
          window.cep.encoding.Base64,
        )

        if (!result.err) {
          resolve({
            ...file,
            path: filePath,
          })
        } else {
          console.log('axios', result.err)
          reject(new Error('Error while writing file'))
        }
      })
    })
  })
}

export const placeImages = async files => {
  // Create temp directory if not exists
  const path =
    window.cs.getSystemPath(SystemPath.USER_DATA) +
    '/com.iconscout.icondrop.adobe/'
  window.cep.fs.makedir(path)

  const downloaded = await Promise.all(downloadFiles(files, path))
  const script =
    'placeImageAdobe("' +
    window.cs.getHostEnvironment().appId +
    '", ' +
    JSON.stringify(downloaded) +
    ');'
  return window.cs.evalScript(script, function() {
    downloaded.forEach(file => {
      window.cep.fs.deleteFile(file)
    })
  })
}

export const syncSelections = async (uuid, token) => {
  return new Promise((resolve, reject) => {
    const path =
      window.cs.getSystemPath(SystemPath.USER_DATA) +
      '/com.iconscout.icondrop.adobe/'
    window.cep.fs.makedir(path)

    const script = `exportSelection("${path}");`
    window.cs.evalScript(script, function(response) {
      const files = JSON.parse(response)
      const promises = files.map(file => uploadFiles(file, { uuid, token }))

      Promise.all(promises).then(resolve)
    })
  })
}

export const uploadFiles = async (files, { uuid, token }) => {
  // Create temp directory if not exists
  // const path = window.cs.getSystemPath(SystemPath.USER_DATA) + '/com.iconscout.icondrop.adobe/'
  // window.cep.fs.makedir(path)
  // const result = window.cep.fs.readFile(path + 'test.txt')

  const form = new FormData()
  form.append('asset', 'myscout')
  form.append('parent_uuid', uuid)
  form.append(
    'source',
    `adobe-${window.cs.getHostEnvironment().appId.toLocaleLowerCase()}`,
  )

  for (let i = 0; i < files.length; i++) {
    const file = files[i]

    const name = path.basename(file)
    const result = window.cep.fs.readFile(file, window.cep.encoding.Base64)
    if (result.err === 0) {
      form.append(`base64_files[${i}][name]`, name)
      form.append(`base64_files[${i}][base64_content]`, result.data)
    } else {
      throw new Error(
        'Sorry! Something went wrong. Message: Export files not found!',
      )
    }
  }

  try {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.api.v2+json',
      Authorization: `Bearer ${token}`,
    }

    const endpoint =
      process.env.VUE_APP_API_SYNC_COMPONENT ||
      process.env.NUXT_ENV_API_SYNC_COMPONENT

    await axios({
      // url: 'https://enn5pg9nvqk1.x.pipedream.net',
      url: endpoint,
      method: 'POST',
      data: form,
      headers,
    })

    window.onComponentsSynced({
      uuid,
    })
  } catch (error) {
    alert(JSON.stringify(error.response))
    throw new Error('Sorry! Something went wrong. Message: ' + error.message)
  }
}
